import { render, staticRenderFns } from "./GroupTree.vue?vue&type=template&id=5080cd02&scoped=true&"
import script from "./GroupTree.vue?vue&type=script&lang=js&"
export * from "./GroupTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080cd02",
  null
  
)

export default component.exports